import { render } from "./profile-identification-natural.vue?vue&type=template&id=1d60386f&scoped=true&ts=true"
import script from "./profile-identification-natural.vue?vue&type=script&lang=ts"
export * from "./profile-identification-natural.vue?vue&type=script&lang=ts"

import "./profile-identification-natural.vue?vue&type=style&index=0&id=1d60386f&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d60386f"]])

export default __exports__